module.exports = {"id":"188599","name":"Mirco Antenucci","rating":"74","photo":"./data/images/photos/0/188599.png","club":{"name":"Spal","logo":"./data/images/clubs/Spal.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MircoAntenucci0.json
// module id = 3052
// module chunks = 0